import { render, staticRenderFns } from "./ContactPersonCard.vue?vue&type=template&id=b9b4b918&scoped=true&"
import script from "./ContactPersonCard.vue?vue&type=script&lang=js&"
export * from "./ContactPersonCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersonCard.vue?vue&type=style&index=0&id=b9b4b918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b4b918",
  null
  
)

export default component.exports